<template>
	<div class="w-full flex flex-col pb-24 dark:bg-stone-700">
		<div class="flex flex-col justify-around items-center text-2xl font-semibold pb-8">
			<div class="w-full flex justify-center">Рейтинг: {{ this.$store.state.user?.rating }}.0</div>
			<!-- <div class="w-full flex justify-center">Баланс: {{ this.$store.state.user?.balance }} поездок</div> -->
		</div>
		<div v-if="offers.length > 0" class="w-full flex flex-col px-1">
			<div v-for="offer in offers" :key="offer.id" class="border dark:border-stone-700 rounded-lg overflow-hidden mb-8 bg-white dark:bg-stone-800" :class="{'opacity-50': !offer.is_active }">
				<div class="flex flex-col gap-1">
					<div class="flex flex-row justify-between pl-4 pt-4 pb-4 pr-8">
						<div class="flex flex-col gap-1 w-full">
							<div class="flex flex-row items-center">
								<!-- <img src="https://img.icons8.com/?size=256w&id=84&format=png" class="h-4 w-6 pr-2"> -->
								{{ offer.departure_city }}
								{{ offer.departure_address }}
								<img src="https://img.icons8.com/?size=256w&id=39803&format=png" class="h-4 h-4 mx-2">
								{{ offer.destination_city }}
								{{ offer.destination_address }}
							</div>
							<div class="flex flex-row items-center">
								<img src="https://img.icons8.com/?size=256w&id=VfeBw5ao3Irv&format=png" class="h-4 w-6 pr-2">
								<div class="flex flex-row items-center gap-1">
									{{ offer.price }}
									<div class="text-sm">₸</div>
								</div>
							</div>
							<div class="flex flex-row items-center">
								<img src="https://img.icons8.com/?size=100&id=2951&format=png" class="h-4 w-6 pr-2">
								<div class="flex flex-row">
									{{ offer.comment }}
								</div>
							</div>
							<!-- <div class="flex flex-row items-center opacity-30">
								<img src="https://img.icons8.com/?size=256&id=10034&format=png" class="h-4 w-6 pr-2">
								<div>{{ offer.views }}</div>
							</div> -->
							<div class="flex flex-row items-center opacity-30">
								<img src="https://img.icons8.com/?size=256&id=10034&format=png" class="h-4 w-6 pr-2">
								<div>{{ offer.publish_at_formatted }}</div>
							</div>
							<div class="flex flex-row items-center">
								<img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-6 pr-2">
								<div>Истекает через {{ formatTimer(offer.time_left) }}</div>
							</div>
							<div class="flex flex-row items-center justify-between w-full">
								<div @click="()=>{renewOffer(offer.id)}"  class="flex flex-row items-center px-4 rounded-md my-2 bg-emerald-100">
									<img src="https://static-00.iconduck.com/assets.00/renew-icon-512x512-ogdeas0f.png" class="h-4 w-4 mr-4">
									<div class="text-emerald-500 font-semibold py-2">Повторить заявку</div>
								</div>
								<div v-if="offer.is_active" @click="()=>{disableOffer(offer.id)}" class="flex flex-row items-center  px-4 rounded-md my-2 bg-rose-50">
									<img src="https://static-00.iconduck.com/assets.00/circle-cross-icon-2048x2048-d94iu2ww.png" class="h-4 w-6 pr-2">
									<div  class="text-rose-500 py-2">Снять заявку</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="flex flex-row items-center h-1 bg-stone-200 w-full">
					<div v-if="offer.is_active" class="h-full bg-lime-500" :style="{'width': (offer.time_left * 100) / offer.expires_after +'%'}"></div>
				</div>
			</div>
		</div>
		<div v-else class="w-full flex flex-col justify-center items-center gap-4" style="height: 50vh">
			<img :src="require('@/assets/checklist-empty-96.png')" class="h-48 mb-16"/>
			<div class="text-3xl">Заявок нет</div>
			<div class="text-xl flex flex-col items-center gap-4">
				<div>Добавьте новую заявку, кликнув по кнопке</div>
				<img :src="require('@/assets/create_offer_icon.png')" />
			</div>
		</div>
		<!-- <div class="h-48 bg-stone-300"></div> -->
	</div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'DashboardHome',
    data () {
        return {
            offers: [],
			offers_update_interval: null
        }
    },
    methods: {
		renewOffer(uid) {
			if (!confirm("Повторить ваш заказ?")) return
			this.postServerData('passenger_offers_reactivate', { data: {id: uid} }).then(()=>{
				setTimeout(this.getMyOffers(), 300)
			})
			.finally(()=> this.$store.dispatch('getUser'))
		},
		disableOffer(uid) {
			this.postServerData('passenger_offers_diactivate', { data: {id: uid} }).then(()=>{
				setTimeout(this.getMyOffers(), 300)
			})
			.finally(()=> this.$store.dispatch('getUser'))
		},
		getMyOffers () {
			this.getServerData('my_passenger_offers').then((res) => {
				res = res.data
				this.offers = res.data
			})
		},
		formatTimer(seconds_left) {
			let mins = Math.floor(seconds_left / 60)
			let secs = Math.floor(seconds_left % 60)
			if (secs < 10) secs = '0' + secs
			let formattedTime = mins + ':' + secs
			return formattedTime
		}
	},
	mounted() {
		this.getMyOffers()
		// this.offers_update_interval = setInterval(()=> { this.getMyOffers() }, 1000)
	},
	unmounted() {
		clearInterval(this.offers_update_interval)
	},

}
</script>
